import React from 'react'
import styled from 'styled-components'
import { Cell, Icons } from '../../styles/styled-common'

const { Xbox, Playstation, Steam } = Icons

const UL = styled.ul`
  list-style: none;
  display: flex !important;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  justify-content: space-around;
  padding: 0 6% !important;
  margin: 0;
`

class Platform extends React.PureComponent {
  render() {
    const { type, ...props } = this.props

    return (
      <li {...props}>
        {type === 'pc' ? (
          <Steam />
        ) : type === 'xbox' ? (
          <Xbox />
        ) : type === 'playstation' ? (
          <Playstation />
        ) : null}
      </li>
    )
  }
}

const StPlatform = styled(Platform)`
  padding: 0 3px;
  max-width: 50%;
  &:first-child {
    margin-left: 0;
  }

  &:only-child {
    max-width: 70%;
  }

  &:last-child {
    margin-right: 0;
  }
  svg {
    height: 100%;
    width: 100%;
  }
`

export default class PlatformsCell extends React.PureComponent {
  render() {
    const { platforms, ...props } = this.props

    /*         const plats = platforms.reduce((sum, plat) => {
            sum[plat] = true
            return sum
        }, {}) */

    const plats = platforms.map(plat => <StPlatform key={plat} type={plat} />)

    return (
      <Cell {...props}>
        <UL>{plats}</UL>
      </Cell>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/PlatformsCell.jsx